export enum PromoFilterEnum {
    STATUS = 'status',
}
